import { hasCapability, type User } from "../base";

export const inbox = {
  list: (user: User) => hasCapability(user, "inbox.list"),
  createView: (user: User) => hasCapability(user, "inbox.createView"),
};
